import { Column } from '../types';

export function getColumnTitles(columns: Column[]): string[] {
  return columns.map((column) => column.title);
}
